// You can customize the template with the help of this file

//Template config options
const themeConfig = {
    app: {
        appName: "Seafarer",
        appLogoImage: require("@src/assets/images/liscr_logo.png"),
        successStatusImage: require("@src/assets/images/success_status.png"),
        errorStatusImage: require("@src/assets/images/error_status.png"),
        ziploader: require("@src/assets/images/loader.gif")
    },
    navicons: {
        dashboard: require("@src/assets/images/nav_icons/dashboard_icon_black.png"),
        dashboard1: require("@src/assets/images/nav_icons/dashboard_icon.png"),

        invoiceD1: require("@src/assets/images/nav_icons/invoice_light.png"),
        invoiceD2: require("@src/assets/images/nav_icons/invoice_dark1.png"),

        kpi: require("@src/assets/images/nav_icons/kpi_light.png"),
        kpi1: require("@src/assets/images/nav_icons/kpi_dark1.png"),

        tcImage: require("@src/assets/images/nav_icons/training_centre.png"),
        tcImage1: require("@src/assets/images/nav_icons/training_centre_1.png"),

        ssImage: require("@src/assets/images/nav_icons/seafarer_student.png"),
        ssImage1: require("@src/assets/images/nav_icons/seafarer_student_1.png"),

        mcImage: require("@src/assets/images/nav_icons/medical_icon.png"),
        mcImage1: require("@src/assets/images/nav_icons/medical_icon_1.png"),

        agent: require("@src/assets/images/nav_icons/agent_light.png"),
        agent1: require("@src/assets/images/nav_icons/agent_dark1.png"),

        home: require("@src/assets/images/nav_icons/home1.png"),
        home1: require("@src/assets/images/nav_icons/home2.png"),

        Search: require("@src/assets/images/nav_icons/search_icon_01.png"),
        Search1: require("@src/assets/images/nav_icons/search_icon.png"),

        Money: require("@src/assets/images/nav_icons/money.png"),
        Money1: require("@src/assets/images/nav_icons/money.png"),

        appSettings: require("@src/assets/images/nav_icons/appSettings.png"),
        appSettings1: require("@src/assets/images/nav_icons/appSettings_01.png"),


        userMangement: require("@src/assets/images/contact-management.png"),
        userMangement1: require("@src/assets/images/contact-management1.png"),

        library: require("@src/assets/images/nav_icons/folder_icon1.png"),
        library1: require("@src/assets/images/nav_icons/folder_icon1.png"),

        subscriptions: require("@src/assets/images/nav_icons/sub_icon.png"),
        subscriptions1: require("@src/assets/images/nav_icons/sub_icon.png"),

        Profile: require("@src/assets/images/nav_icons/account_icon_01.png"),
        Profile1: require("@src/assets/images/nav_icons/account_icon.png"),

        dlibrary: require("@src/assets/images/nav_icons/folder_black.png"),
        logout: require("@src/assets/images/navicons/user_profile.png"),
        notification: require("@src/assets/images/navicons/notification.svg"),
        user: require("@src/assets/images/navicons/user_profile.png"),

        rotate: require("@src/assets/images/nav_icons/rotate-right.png"),
        more: require("@src/assets/images/nav_icons/more.png"),
        rotate1: require("@src/assets/images/nav_icons/rotate_right1.png"),
        more1: require("@src/assets/images/nav_icons/more1.png"),
        invoice: require("@src/assets/images/invoice.png"),
        Right_Tick: require("@src/assets/images/nav_icons/Right_Tick.png"),
        waypoint: require("@src/assets/images/nav_icons/waypoint.png"),
        peopleOutline: require("@src/assets/images/nav_icons/people-outline.png"),
        cloudOutline: require("@src/assets/images/nav_icons/cloud-outline.png"),
        billing: require("@src/assets/images/nav_icons/billing.png")
    },
    layout: {
        isRTL: false,
        skin: "light", // light, dark, bordered, semi-dark
        type: "vertical", // vertical, horizontal
        contentWidth: "boxed", // full, boxed
        menu: {
            isHidden: false,
            isCollapsed: false
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: "sticky", // static , sticky , floating, hidden
            backgroundColor: "white" // BS color options [primary, success, etc]
        },
        footer: {
            type: "static" // static, sticky, hidden
        },
        customizer: false,
        scrollTop: true, // Enable scroll to top button
        toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
    }
    // layout: {
    //   isRTL: false,
    //   skin: "light", // light, dark, bordered, semi-dark
    //   type: "vertical", // vertical, horizontal
    //   contentWidth: "boxed", // full, boxed
    //   menu: {
    //     isHidden: false,
    //     isCollapsed: false
    //   },
    //   navbar: {
    //     // ? For horizontal menu, navbar type will work for navMenu type
    //     type: "sticky", // static , sticky , floating, hidden
    //     backgroundColor: "white" // BS color options [primary, success, etc]
    //   },
    //   footer: {
    //     type: "static" // static, sticky, hidden
    //   },
    //   customizer: false,
    //   scrollTop: true, // Enable scroll to top button
    //   toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
    // }
}

export default themeConfig
